var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"mt-5 mb-5",attrs:{"color":"primary","prominent":"","text":""}},[_c('small',[_vm._v(_vm._s(_vm.$t("messages.section_complete")))])])}
var staticRenderFns = []

export { render, staticRenderFns }